// extracted by mini-css-extract-plugin
export default {"body":"TodoList_body__JKDUd","line":"TodoList_line__GS4Ge","item":"TodoList_item__Lh+fT"};